import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography } from '../../../../../../components/mui/Core/index'
import Constants from '../../../../../../constants/en.json'
import {
  fetchClientWarehouseCode,
  resetIsInviteConfirmed,
  setSelectedOrganization,
} from '../../invite-user-modal-slice'
import { appNameConstants } from '../../../../../../constants/app-constants'
import GenericAutocomplete from '../../../../../../components/dropdowns/GenericAutocomplete/generic-autocomplete'

function SelectOrganization() {
  const dispatch = useDispatch()
  const clients = useSelector((state) => state.staticData.clients)
  const customers = useSelector((state) => state.staticData.customers)
  const userEmail = useSelector((state) => state.inviteUser.email)
  const selectedRole = useSelector((state) => state.inviteUser.selectedRole)
  const dropdownOptions = getDropdownOptions()
  const selectedOrganization = useSelector((state) => state.inviteUser.selectedOrganization)
  const currentOption = selectedOrganization ? getCurrentOption() : null

  function getDropdownOptions() {
    switch (selectedRole?.appName) {
      case appNameConstants.CLIENT_PORTAL:
        return clients.map((client) => ({
          id: client.clientCode,
          description: client.clientShortName,
        }))
      case appNameConstants.CUSTOMER_PORTAL:
        return customers.map((customer) => ({
          id: customer.customerNumber,
          description: customer.customerName,
        }))
      default:
        return []
    }
  }

  function getCurrentOption() {
    switch (selectedRole?.appName) {
      case appNameConstants.CLIENT_PORTAL: {
        const option = dropdownOptions.filter(
          (organization) => organization.id === selectedOrganization?.clientCode,
        )
        return option[0]
      }
      case appNameConstants.CUSTOMER_PORTAL: {
        const option = dropdownOptions.filter(
          (organization) => organization.id === selectedOrganization?.customerNumber,
        )
        return option[0]
      }
      default:
        return null
    }
  }

  function getSelectedOrganization(organization) {
    switch (selectedRole?.appName) {
      case appNameConstants.CLIENT_PORTAL: {
        const option = clients.filter((client) => client.clientCode === organization.id)
        return option[0]
      }
      case appNameConstants.CUSTOMER_PORTAL: {
        const option = customers.filter((customer) => customer.customerNumber === organization.id)
        return option[0]
      }
      default:
        return null
    }
  }

  const handleSelectOrganization = (event) => {
    const organization = getSelectedOrganization(event)
    dispatch(setSelectedOrganization(organization))
    if (selectedRole?.appName === appNameConstants.CLIENT_PORTAL) {
      const request = { clientCode: event.id }
      dispatch(fetchClientWarehouseCode(request))
    }
    dispatch(resetIsInviteConfirmed())
  }

  const rootStyle = { minHeight: '257px' }
  const emailContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
  }
  const roleContainerStyle = { display: 'flex', justifyContent: 'space-between', marginTop: '12px' }
  const organizationContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
  }
  const selectOrganizationStyle = { marginTop: '8px' }

  return (
    <Box sx={rootStyle}>
      <Box>
        <Typography variant='cardHeader'>
          {Constants.userManagement.inviteUser.INVITE_USER}
        </Typography>
      </Box>
      <Box sx={emailContainerStyle}>
        <Box>
          <Typography>{Constants.userManagement.inviteUser.USER_EMAIL}:</Typography>
        </Box>
        <Box>
          <Typography>{userEmail}</Typography>
        </Box>
      </Box>
      <Box sx={roleContainerStyle}>
        <Box>
          <Typography>{Constants.userManagement.inviteUser.USER_ROLE}:</Typography>
        </Box>
        <Box>
          <Typography>{selectedRole?.roleDescription}</Typography>
        </Box>
      </Box>
      <Box sx={organizationContainerStyle}>
        <Box>
          <Typography>{Constants.userManagement.inviteUser.USER_ORGANIZATION}</Typography>
        </Box>
        <Box sx={selectOrganizationStyle}>
          <GenericAutocomplete
            width='448px'
            label={Constants.userManagement.inviteUser.ORGANIZATION}
            dropdownOptions={dropdownOptions}
            selectedOption={currentOption}
            handleSelectOption={handleSelectOrganization}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default SelectOrganization
